// extracted by mini-css-extract-plugin
export default {"channelsPanel":"_3deDB","channels":"Y5ln8","channel":"fZWo8","selected":"SwhPk","selectedChannelBackground":"Th7GO"};